import { eventBus } from "../main";

export default {
  methods: {
    nextPage(p) {
      this.progress = true;
      eventBus.$emit("next_page", p);
    },
    nextChapter(p) {
      this.progress = true;
      eventBus.$emit("next_chapter", p);
    },
    lastPage(p) {
      this.progress = true;
      eventBus.$emit("last_page", p);
    }
  },
}